import React from 'react';
import { SearchProvider } from '../contexts/searchContext';
import { PersonEditorProvider } from '../contexts/personEditorContext';

/**
 * DataProvider - Consolidates all data-related context providers
 *
 * Now uses unified SearchProvider which combines:
 * - DatasetProvider (datasets, selectedDataset, datasetMap)
 * - ApplicationProvider (enumMap, searchString, triggers)
 * - FilteredPeopleProvider (filteredPeople, matchSource, matchAccuracy)
 * - SelectedCharacteristicsProvider (selectedCharacteristics)
 * - TriggerProvider (removed - unused)
 *
 * This reduces provider nesting from 6 levels to 2 levels.
 */
export function DataProvider({ children }) {
  return (
    <SearchProvider>
      <PersonEditorProvider>
        {children}
      </PersonEditorProvider>
    </SearchProvider>
  );
}
